import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";

import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Journey from "@/components/landing/Journey";
import Engines from "@/components/landing/Engines";
import Score from "@/components/landing/Score";
import Intelligence from "@/components/landing/Intelligence";
import Revenue from "@/components/landing/Revenue";
import Assistant from "@/components/landing/Assistant";
import DemoCampaign from "@/components/landing/DemoCampaign";
import Waitlist from "@/components/landing/Waitlist";
import Footer from "@/components/landing/Footer";

import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";
import ForgotPassword from "@/pages/auth/ForgotPassword";
import ResetPassword from "@/pages/auth/ResetPassword";
import VerifyEmail from "@/pages/auth/VerifyEmail";
import AuthCallback from "@/pages/auth/AuthCallback";

import AppLayout from "@/components/app/AppLayout";
import Overview from "@/pages/app/Overview";
import Products from "@/pages/app/Products";
import ProductDetail from "@/pages/app/ProductDetail";
import Campaigns from "@/pages/app/Campaigns";
import CampaignDetail from "@/pages/app/CampaignDetail";
import Prospects from "@/pages/app/Prospects";
import ProspectDetail from "@/pages/app/ProspectDetail";
import Pipeline from "@/pages/app/Pipeline";
import FollowUps from "@/pages/app/FollowUps";
import Leads from "@/pages/app/Leads";
import Analytics from "@/pages/app/Analytics";
import AssistantPage from "@/pages/app/Assistant";
import EnginesPage from "@/pages/app/Engines";

const Landing = () => (
  <div data-testid="landing-page" className="relative bg-[#050505] text-white">
    <div className="grain-overlay" aria-hidden="true" />
    <Nav />
    <main>
      <Hero />
      <Journey />
      <Engines />
      <Score />
      <Intelligence />
      <Revenue />
      <Assistant />
      <DemoCampaign />
      <Waitlist />
    </main>
    <Footer />
  </div>
);

function AppRouter() {
  const location = useLocation();
  // Google OAuth returns with #session_id=... — handle before any other routing.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/app" element={<AppLayout />}>
        <Route index element={<Overview />} />
        <Route path="products" element={<Products />} />
        <Route path="products/:productId" element={<ProductDetail />} />
        <Route path="campaigns" element={<Campaigns />} />
        <Route path="campaigns/:campaignId" element={<CampaignDetail />} />
        <Route path="prospects" element={<Prospects />} />
        <Route path="prospects/:prospectId" element={<ProspectDetail />} />
        <Route path="pipeline" element={<Pipeline />} />
        <Route path="follow-ups" element={<FollowUps />} />
        <Route path="leads" element={<Leads />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="assistant" element={<AssistantPage />} />
        <Route path="engines" element={<EnginesPage />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
